module.exports = __webpack_public_path__ + "static/media/pic1.f02ea609.jpg";